import { format, parseISO, isValid } from "date-fns";
import { ru } from "date-fns/locale";

const extractTimeParts = (value) => {
  if (typeof value !== "string") return null;

  const match = value.match(/T(\d{2}):(\d{2})(?::\d{2})?/);
  if (!match) return null;

  return {
    hours: match[1],
    minutes: match[2],
  };
};

const toDate = (value) => {
  if (!value) return null;
  const date = typeof value === "string" ? parseISO(value) : new Date(value);
  return isValid(date) ? date : null;
};

export const formatTime = (value, pattern = "HH:mm") => {
  const timeParts = extractTimeParts(value);

  if (timeParts) {
    if (pattern === "HH") {
      return timeParts.hours;
    }

    if (pattern === "HH:mm") {
      return `${timeParts.hours}:${timeParts.minutes}`;
    }
  }

  const date = toDate(value);
  return date ? format(date, pattern) : "";
};

export const formatDateRu = (value, pattern = "d MMMM") => {
  const date = toDate(value);
  if (!date) return "";
  const formatted = format(date, pattern, { locale: ru });
  return formatted.replace(/\p{L}/u, (char) => char.toUpperCase());
};
